/* PW header/chat layering: safe periodic repair for async injected widgets. */
(function(){
  'use strict';
  if(window.__pwHeaderLayerV3)return;
  window.__pwHeaderLayerV3=true;
  var rx=/zendesk|zdassets|webwidget|messaging|shop.with.ai|clarity/i;
  function repair(){
    document.querySelectorAll('iframe,[id*="webWidget" i],[id*="zendesk" i],[title*="Chat" i],[title*="Shop with AI" i]').forEach(function(n){
      var label=[n.id,n.getAttribute('title'),n.getAttribute('src'),n.getAttribute('class'),n.getAttribute('aria-label')].join(' ');
      if(!rx.test(label))return;
      var rect=n.getBoundingClientRect();
      if(rect.width<100||rect.height<80)return;
      n.style.setProperty('z-index','2147483000','important');
      var p=n.parentElement;
      while(p&&p!==document.body){
        var s=getComputedStyle(p);
        if((s.position==='fixed'||s.position==='absolute')&&s.zIndex!=='auto'){
          p.style.setProperty('z-index','2147483000','important');
        }
        p=p.parentElement;
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',repair);
  else repair();
  window.addEventListener('load',repair);
  setInterval(repair,1200);
})();